if (!customElements.get('holy-animated-hero')) {
  customElements.define('holy-animated-hero', class extends HTMLElement {
    connectedCallback() {
      this.raf = 0;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.onScroll = () => this.queue();
      this.onPointer = (event) => {
        if (this.reduced) return;
        const rect = this.getBoundingClientRect();
        const x = Math.max(-1, Math.min(1, ((event.clientX - rect.left) / rect.width - .5) * 2));
        const y = Math.max(-1, Math.min(1, ((event.clientY - Math.max(rect.top, 0)) / Math.min(rect.height, innerHeight) - .5) * 2));
        this.style.setProperty('--mx', x.toFixed(3));
        this.style.setProperty('--my', y.toFixed(3));
      };
      this.onLeave = () => {
        this.style.setProperty('--mx', '0');
        this.style.setProperty('--my', '0');
      };
      addEventListener('scroll', this.onScroll, { passive: true });
      addEventListener('resize', this.onScroll, { passive: true });
      this.addEventListener('pointermove', this.onPointer, { passive: true });
      this.addEventListener('pointerleave', this.onLeave, { passive: true });
      this.update();
    }
    disconnectedCallback() {
      removeEventListener('scroll', this.onScroll);
      removeEventListener('resize', this.onScroll);
      this.removeEventListener('pointermove', this.onPointer);
      this.removeEventListener('pointerleave', this.onLeave);
      cancelAnimationFrame(this.raf);
    }
    queue() {
      if (this.raf) return;
      this.raf = requestAnimationFrame(() => { this.raf = 0; this.update(); });
    }
    update() {
      const rect = this.getBoundingClientRect();
      const distance = Math.max(1, this.offsetHeight - innerHeight);
      const p = Math.max(0, Math.min(1, -rect.top / distance));
      const reveal = p < .32 ? 0 : p > .68 ? 1 : (p - .32) / .36;
      const eased = reveal * reveal * (3 - 2 * reveal);
      this.style.setProperty('--p', p.toFixed(4));
      this.style.setProperty('--brown-reveal', eased.toFixed(4));
      this.classList.toggle('is-brown', p > .5);
    }
  });
}